import { render, staticRenderFns } from "./LeftMenu.vue?vue&type=template&id=62fcf2a1"
import script from "./LeftMenu.vue?vue&type=script&lang=js"
export * from "./LeftMenu.vue?vue&type=script&lang=js"
import style0 from "./LeftMenu.vue?vue&type=style&index=0&id=62fcf2a1&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports